import Vue from 'vue';
import Vuex, { MutationTree, ActionTree } from 'vuex';
import { Photo } from '../../../models/photo';
import { ProposalMatch } from '../../../models/proposalmatch';
import axios from 'axios';

Vue.use(Vuex);

interface State {
    photos: Photo[];
    photosOverview: Photo[];
}

const mutations: MutationTree<State> = {
    setPhotos: (currentState, photos) => (currentState.photos = photos),
    setPhotosOverview: (currentState, photos) => (currentState.photosOverview = photos),
};

const actions: ActionTree < State, any > = {

};

const getters = {
    photos(currentState: State)  {
        return currentState.photos;
    },

    photosOverview(currentState: State) {
        return currentState.photosOverview;
    },

    coverPhoto: (currentState) => (proposalMatch: ProposalMatch) => {
        // Filter out all other proposal photos
        const photosProposal: Photo[] = currentState.photos.filter(function(photo: Photo) {
            return photo.proposal_id === proposalMatch.proposal_id;
        });

        // Return the last as cover
        if (photosProposal.length > 0) {
            return photosProposal[photosProposal.length - 1];
        }
    },
};

const state: State = {
    photos: Array<Photo>(),
    photosOverview: Array<Photo>(),
};

const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};

export default module;
